import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Toggles from './toggles';
import { useLang } from '../context/langcontext';
import { FaApple, FaGooglePlay, FaChevronDown } from 'react-icons/fa';

const Navbar = () => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);
  const { t } = useLang();
  const [showDropdown, setShowDropdown] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const dropdownRef = useRef();

  const links = [
    { key: 'home', path: '/' },
    { key: 'about', path: '/about' },
    { key: 'vendors', path: '/vendors' },
    { key: 'contact', path: '/contact' },
    { key: 'register', path: '/register' },
  ];

  // Close download dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav>
      <div className="nav-content">
        {/* Download App Button */}
        <div className="download-app" ref={dropdownRef}>
          <button onClick={() => setShowDropdown(!showDropdown)}>
            {t('downloadApp')} <FaChevronDown size={14} />
          </button>
          {showDropdown && (
            <div className="dropdown">
              <a
                href="https://apps.apple.com/om/app/selal/id6596748079"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaApple /> {t('appStore')}
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.selal.app&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaGooglePlay /> {t('playStore')}
              </a>
            </div>
          )}
        </div>

        {/* Hamburger for Mobile */}
        <div
          className={`hamburger ${mobileMenu ? 'active' : ''}`}
          onClick={() => setMobileMenu(!mobileMenu)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Nav Links */}
        <ul className={mobileMenu ? 'show' : ''}>
          {links.map(link => (
            <li key={link.key}>
              <Link
                to={link.path}
                className={activeLink === link.path ? 'active' : ''}
                onClick={() => {
                  setActiveLink(link.path);
                  setMobileMenu(false); // close menu on mobile
                }}
              >
                {t(link.key)}
              </Link>
            </li>
          ))}
        </ul>

        {/* Toggles on the right */}
        <Toggles />
      </div>
    </nav>
  );
};

export default Navbar;
